// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3IYTM","label":"Completed_label__3xnYd"};